"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledDeletionWrapper = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Container_1 = require("../Container");
var Footer_1 = require("../Footer");
var ScheduledDeletionWrapper = function (props) {
    return (React.createElement(sok_ui_1.Overlay, { isOpen: props.mode === 'TTL', onClose: props.closeDialog },
        React.createElement(sok_ui_1.SideMenu, { className: 'sok-scheduled-deletion', isOpen: props.mode === 'TTL', docked: false, orientation: 'right' },
            React.createElement(sok_ui_1.Header, { onClose: props.closeDialog }, (0, translation_1.getLocalization)('userfront/project/ScheduledDeletion/header')),
            React.createElement(Container_1.Container, __assign({}, props)),
            React.createElement(Footer_1.Footer, __assign({}, props)))));
};
exports.ScheduledDeletionWrapper = ScheduledDeletionWrapper;
